import { call, put, select, takeLatest } from "redux-saga/effects";
import { getType } from "typesafe-actions";
import { createExhibitActions, exhibitActions, exhibitsActions, updateExhibitActions } from "./exhibits.actions";
import { createExhibitApi, getExhibitApi, getExhibitsApi, updateExhibitApi, uploadContentImageApi } from "./exhibits.api";
import { ExhibitDto } from "./exhibits.dtos";

function* setExhibits(result: ExhibitDto[], newItems: ExhibitDto[]) {
    result.forEach(i => {
      let oldItemIndex = newItems.findIndex(s => s.id === i.id);
      if (oldItemIndex === -1) newItems.push(i);
      else newItems[oldItemIndex] = i;
    }); 
    yield put({ type: getType(exhibitsActions.success), payload: newItems });
    sessionStorage.setItem(`exhibits`, JSON.stringify(newItems));
}

function* handleGetExhibits(request: ReturnType<typeof exhibitsActions.request>) {
    const exhibits: ExhibitDto[] = yield call(getExhibitsApi);
  
    yield put({ type: getType(exhibitsActions.success), payload: exhibits });
    sessionStorage.setItem(`exhibits`, JSON.stringify(exhibits));
}

function* handleGetExhibit(request: ReturnType<typeof exhibitActions.request>) {
    const exhibit: ExhibitDto =  yield call(getExhibitApi, request.payload);
  
    yield put({ type: getType(exhibitActions.success), payload: exhibit });
}

function* handleUpdateExhibit(request: ReturnType<typeof updateExhibitActions.request>) {
    const storeList = yield select(state => state.exhibits.list);
    const updatedExhibit: ExhibitDto = yield call(updateExhibitApi, request.payload);
  
    yield put({ type: getType(exhibitActions.success), payload: updatedExhibit });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setExhibits([updatedExhibit], JSON.parse(JSON.stringify(storeList)) as ExhibitDto[]);
}
  
function* handleCreateExhibit(request: ReturnType<typeof createExhibitActions.request>) {
    const storeList = yield select(state => state.exhibits.list);
    const createdExhibit: ExhibitDto = yield call(createExhibitApi, request.payload);
  
    yield put({ type: getType(exhibitActions.success), payload: createdExhibit });
  
    if (storeList !== undefined && storeList.length !== 0)
      yield setExhibits([createdExhibit], JSON.parse(JSON.stringify(storeList)) as ExhibitDto[]);

    
  window.location.href = `/exhibits/${createdExhibit.id}`;
}

// function* handleUploadContentImage(request: ReturnType<typeof updateExhibitActions.request>) {
//   const createdExhibit: ExhibitDto = yield call(uploadContentImageApi, request.payload);

//   yield put({ type: getType(exhibitActions.success), payload: createdExhibit });
// }

export function* watchGetExhibitsRequest() {
    try {
      yield takeLatest(getType(exhibitsActions.request), handleGetExhibits);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchGetExhibitRequest() {
    try {
      yield takeLatest(getType(exhibitActions.request), handleGetExhibit);
    }
    catch (err) {
      console.log(err);
    }
}

export function* watchUpdateExhibitRequest() {
    try {
      yield takeLatest(getType(updateExhibitActions.request), handleUpdateExhibit);
    }
    catch (err) {
      console.log(err);
    }
}
  
export function* watchCreateExhibitRequest() {
    try {
      yield takeLatest(getType(createExhibitActions.request), handleCreateExhibit);
    }
    catch (err) {
      console.log(err);
    }
}